export default __webpack_public_path__ + "static/media/PL001.3.9880b55a.mp3";